/**
 * Service doing get operation on instances of `ReportTemplate`.
 *
 * @param {Repository} reportTemplateRepository - Repository to fetch the ReportTemplates
 */
export default class ReportTemplateForForecastingService {
	constructor({ reportTemplateRepository }) {
		this._reportTemplateRepository = reportTemplateRepository;
	}

	/**
	 * Get a ReportTemplates using filter.
	 *
	 * @param {object} filter - filter to complete the URL
	 */
	getReportTemplates({ filter }) {
		return Promise.all([
			this._getReportTemplate({
				id: "income-statement",
				filter,
				accountVisibility: 1,
			}),
			this._getReportTemplate({
				id: "balance-sheet",
				filter,
				accountVisibility: 1,
			}),
			this._getReportTemplate({
				id: "cash-flow-report",
				filter,
				accountVisibility: 2,
			}),
		]);
	}

	async _getReportTemplate({ id, filter, accountVisibility }) {
		const reportTemplateData = await this._reportTemplateRepository.get({
			notify: false,
			filter: { ...filter, id },
		});

		if (!reportTemplateData) return null;

		reportTemplateData.columns = [];

		reportTemplateData.displaySettings.accountVisibility =
			accountVisibility;

		return reportTemplateData;
	}
}
